export default function () {
  if (document.getElementById('space-contact-app')) {
    import(/* webpackChunkName: "space-contact" */ '../_03_organisms/page-space/contact/main');
  }
}
